module.exports = __webpack_public_path__ + "fonts/remixicon.37364e27.ttf";